import { action } from 'typesafe-actions';
import { CrossSellItemsResponseProps, Types } from './types';
import { NewCartItem } from '../../../services/MVP/models';
import { AxiosInstance } from 'axios';

interface Props {
  cartItems?: NewCartItem[];
  divisions?: string[];
  businessPartners: string[];
  soldTo?: string;
  commerceApi: AxiosInstance;
  useNewFlow: boolean;
  scope?: string;
}

export const cleanCrossSellState = () => action(Types.CLEAN_CROSS_SELL_STATE);

export const loadCrossSellItems = (props: Props) =>
  action(Types.LOAD_CROSS_SELL_ITEMS, { ...props });

export const loadCrossSellItemsSuccess = (
  response: CrossSellItemsResponseProps
) =>
  action(Types.LOAD_CROSS_SELL_ITEMS_SUCCESS, {
    items: response.items,
    selectedBusinessPartner: response.selected_business_partner
  });

export const loadCrossSellItemsFailure = (error: unknown) =>
  action(Types.LOAD_CROSS_SELL_ITEMS_FAILURE, { error });

export const removeCrossSellItem = (sku: string) =>
  action(Types.REMOVE_CROSS_SELL_ITEM, { sku });

export const addCrossSellSku = (sku: string, screenName: string) =>
  action(Types.ADD_CROSS_SELL_SKU, { sku, screenName });

export const cleanCrossSellItems = () => action(Types.CLEAN_CROSS_SELL_ITEMS);

export const checkCrossSellAvailable = (props: Props) =>
  action(Types.CHECK_CROSS_SELL_AVAILABLE, { ...props });
